import { createDataSchema } from '../schemaUtils'
import * as yup from 'yup'

export const dataSchema = createDataSchema(
	'TPAWidget',
	yup.object({
		appDefinitionName: yup.string(),
		appDefinitionId: yup.string(),
		applicationId: yup.string(),
		tpaData: yup.string().nullable(),
		widgetId: yup.string(),
		referenceId: yup.string().nullable(),
	})
)
